import { useTranslation } from 'next-i18next'

import { TopicGroup } from '~/landingV4/types/topics.types'

interface Props {
  group: TopicGroup
}

export default function TopicGroupRow({ group }: Props): React.ReactElement {
  const { t } = useTranslation('abTestLanding')
  const pills = t(group.pillsKey, { returnObjects: true }) as unknown as string[]

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex w-full items-center gap-3">
        <span
          className={`shrink-0 rounded-1.5 px-3 py-1 text-xxs font-bold uppercase tracking-wide text-white ${group.badgeClass}`}
        >
          {t(group.badgeKey)}
        </span>
        <span className="h-px flex-1 bg-white/20" />
      </div>

      <div className="flex flex-wrap gap-3">
        {pills.map((pill) => (
          <span
            className="rounded-full border border-white/20 bg-white/10 px-5 py-2.5 text-xs font-semibold text-white"
            key={pill}
          >
            {pill}
          </span>
        ))}
      </div>
    </div>
  )
}
